import './style.scss';
import './editor.scss';
import Swiper from 'swiper/bundle';

document.addEventListener( 'DOMContentLoaded', function () {
	// import Swiper JS
	const carousels = document.querySelectorAll( '.swiper__programs' );
	if ( carousels ) {
		carousels.forEach( ( carousel ) => {
			const id = carousel.id;
			if ( id ) {
				const nextButton = carousel.querySelector(
					'.swiper-button-next'
				);
				const prevButton = carousel.querySelector(
					'.swiper-button-prev'
				);
				const paginator =
					carousel.querySelector( '.swiper-pagination' );

				const swiperCarousel = new Swiper( `#${ id }`, {
					centeredSlides: false,
					grabCursor: true,
					spaceBetween: 30,
					slideToClickedSlide: true,

					// Rotation
					autoplay: {
						delay: 7000,
						disableOnInteraction: false,
					},

					// Navigation arrows
					navigation: {
						nextEl: nextButton,
						prevEl: prevButton,
					},

					pagination: {
						el: paginator,
						clickable: true,
					},

					breakpoints: {
						320: {
							slidesPerView: 1,
						},
						576: {
							slidesPerView: 1,
						},
						768: {
							slidesPerView: 2,
						},
						992: {
							slidesPerView: 3,
						},
					},
				} );

				swiperCarousel.autoplay.stop();

				const playPauseButton = carousel.querySelector(
					'.swiper-button-play-pause'
				);

				if ( playPauseButton ) {
					playPauseButton.addEventListener( 'click', function ( e ) {
						const arialLabel =
							playPauseButton.getAttribute( 'aria-label' );
						if ( arialLabel == 'play' ) {
							swiperCarousel.autoplay.start();
							playPauseButton.setAttribute(
								'aria-label',
								'pause'
							);
						} else {
							swiperCarousel.autoplay.pause();
							playPauseButton.setAttribute(
								'aria-label',
								'play'
							);
						}
					} );
				}
			}
		} );
	}

	const feedItemsSameHeight = () => {
		const carousels = document.querySelectorAll( '.block__feed' );
		if ( carousels ) {
			carousels.forEach( ( carousel ) => {
				const items = carousel.querySelectorAll( '.card .card__body' );
				items.forEach( ( item ) => {
					item.style.minHeight = '0';
				} );
				// reset the height
				// set the height

				let maxHeight = 0;
				items.forEach( ( item ) => {
					const itemHeight = item.offsetHeight;
					if ( maxHeight < itemHeight ) {
						maxHeight = itemHeight;
					}
				} );

				items.forEach( ( item ) => {
					item.style.minHeight = maxHeight + 'px';
				} );
			} );
		}
	};

	const setFeedItemsSameHeight = setInterval( () => {
		const feedCard = document.querySelector( '.block__feed' );
		if (
			feedCard !== null &&
			! feedCard.classList.contains( 'height-set' )
		) {
			feedItemsSameHeight();
			feedCard.classList.add( 'height-set' );
		} else {
			clearInterval( setFeedItemsSameHeight );
		}
	}, 100 );

	let windowWidth = window.innerWidth;
	// Trigers when resize window
	const reportWindowSize = () => {
		if ( windowWidth !== window.innerWidth ) {
			feedItemsSameHeight();
			windowWidth = window.innerWidth;
		}
	};

	window.addEventListener( 'resize', reportWindowSize );
} );
